import React, { Fragment, useEffect } from 'react'
import { Stack } from '@mui/material'
import { useApi } from '../../hooks/useApi'
import { ApiResponse } from '../../typings/ApiResponse'
import axios from 'axios'
import { ApiConfig } from '../../config/api'
import { WorkOrderBlogTable } from './WorkOrderBlogTable'
import { WorkOrderBlog } from '../../interfaces/WorkOrder/WorkOrderBlog'
import { WorkOrderBlogForm } from './WorkOrderBlogForm'
import { Status } from '../../hooks/useFetchState'

interface WorkOrderBlogProps {
  workOrderId: number
}

const getWorkOrderBlogs = (
  workOrderId: number,
  page?: number,
  pageSize?: number
) => {
  const url = new URL(`${ApiConfig.WorkOrderBlog}`)

  url.searchParams.set('pageIndex', page?.toString() || '')
  url.searchParams.set('pageSize', pageSize?.toString() || '')
  url.searchParams.set('workOrderId', workOrderId.toString())

  return axios.get(url.toString())
}

export const WorkOrderBlogComponent: React.FC<WorkOrderBlogProps> = ({
  workOrderId
}) => {
  const { state, callApi } = useApi<ApiResponse<WorkOrderBlog>>()

  const requestWorkOrderBlogs = () => {
    callApi(getWorkOrderBlogs(workOrderId, 0, 100))
  }

  useEffect(() => {
    requestWorkOrderBlogs()
  }, [])

  return (
    <Fragment>
      <Stack spacing={2}>
        <WorkOrderBlogTable
          workOrderBlogs={state.data?.items || []}
          isLoading={state.status === Status.Loading}
        />
        <WorkOrderBlogForm
          workOrderId={workOrderId}
          getWorkOrderBlogs={requestWorkOrderBlogs}
        />
      </Stack>
    </Fragment>
  )
}
